var chunkMapping = {
	"242": [
		80242
	],
	"3796": [
		73796
	],
	"5380": [
		85380
	],
	"6799": [
		6799
	],
	"6811": [
		26811
	]
};
var idToExternalAndNameMapping = {
	"6799": [
		"default",
		"./LoginModal",
		90806
	],
	"26811": [
		"default",
		"./AppShellProvider",
		90806
	],
	"73796": [
		"default",
		"./AppShell",
		90806
	],
	"80242": [
		"default",
		"./Header",
		90806
	],
	"85380": [
		"default",
		"./Footer",
		90806
	]
};
var idToRemoteMap = {
	"6799": [
		{
			"externalType": "script",
			"name": "appShell"
		}
	],
	"26811": [
		{
			"externalType": "script",
			"name": "appShell"
		}
	],
	"73796": [
		{
			"externalType": "script",
			"name": "appShell"
		}
	],
	"80242": [
		{
			"externalType": "script",
			"name": "appShell"
		}
	],
	"85380": [
		{
			"externalType": "script",
			"name": "appShell"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"6799": {
		"shareScope": "default",
		"name": "./LoginModal",
		"externalModuleId": 90806,
		"remoteName": "appShell"
	},
	"26811": {
		"shareScope": "default",
		"name": "./AppShellProvider",
		"externalModuleId": 90806,
		"remoteName": "appShell"
	},
	"73796": {
		"shareScope": "default",
		"name": "./AppShell",
		"externalModuleId": 90806,
		"remoteName": "appShell"
	},
	"80242": {
		"shareScope": "default",
		"name": "./Header",
		"externalModuleId": 90806,
		"remoteName": "appShell"
	},
	"85380": {
		"shareScope": "default",
		"name": "./Footer",
		"externalModuleId": 90806,
		"remoteName": "appShell"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}